/**
 * Join person name parts without showing null/undefined/blank/"null".
 */
export function formatPersonNameParts(...parts) {
  return parts
    .filter((v) => v != null && String(v).trim() !== '' && String(v).toLowerCase() !== 'null')
    .map((v) => String(v).trim())
    .join(' ');
}

/**
 * Display name: salutation + first + last, optional ( job_title ).
 */
export function formatContactPersonDisplay(person) {
  if (!person) return '';
  const name = formatPersonNameParts(person.salutation, person.first_name, person.last_name);
  const job =
    person.job_title != null &&
    String(person.job_title).trim() !== '' &&
    String(person.job_title).toLowerCase() !== 'null'
      ? ` ( ${String(person.job_title).trim()} )`
      : '';
  return `${name}${job}`.trim();
}
